import { Currency, Token } from '@uniswap/sdk-core'

export function currencyId(currency: Currency): string {
  if (currency.symbol === 'HBAR') return 'HBAR'
  if (currency instanceof Token) return currency.address
  throw new Error('invalid currency')
}
